import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useApi } from '@/lib/api'
import type { Recurso, RecursoEntrada } from '@/lib/schemas/recursos'

const jsonInit = (metodo: 'POST' | 'PUT', cuerpo?: unknown): RequestInit => ({
  method: metodo,
  ...(cuerpo === undefined
    ? {}
    : { headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(cuerpo) }),
})

/** Los recursos del cliente del proyecto: iguales en todos sus proyectos. */
export function useRecursos(proyectoId: string, mostrarDeBaja: boolean) {
  const api = useApi()
  const params = new URLSearchParams({ proyecto: proyectoId })
  if (mostrarDeBaja) params.set('baja', '1')
  return useQuery({
    queryKey: ['recursos', proyectoId, mostrarDeBaja],
    queryFn: () => api<Recurso[]>(`/api/recursos?${params.toString()}`),
    enabled: Boolean(proyectoId),
    placeholderData: (previa) => previa,
  })
}

function useInvalidar() {
  const qc = useQueryClient()
  return () => qc.invalidateQueries({ queryKey: ['recursos'] })
}

export function useGuardarRecurso() {
  const api = useApi()
  const invalidar = useInvalidar()
  return useMutation({
    mutationFn: ({ id, datos }: { id: string | null; datos: RecursoEntrada }) =>
      id
        ? api<null>(`/api/recursos/${id}`, jsonInit('PUT', datos))
        : api<{ id: string }>('/api/recursos', jsonInit('POST', datos)),
    onSuccess: invalidar,
  })
}

export function useBajaRecurso() {
  const api = useApi()
  const invalidar = useInvalidar()
  return useMutation({
    mutationFn: ({ id, restaurar }: { id: string; restaurar: boolean }) =>
      api<null>(
        `/api/recursos/${id}/${restaurar ? 'restaurar' : 'baja'}`,
        jsonInit('POST'),
      ),
    onSuccess: invalidar,
  })
}
